import React from 'react';
import "./footer.css";
import Logo from "../../icons/Full_Logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.open("/#" + sectionId, "_self");
    }
  };

  const navigateTo = (route) => {
    window.open(route, "_self");
  };

  return (
    <footer className='footer'>
      <div className='footer-content'>
        <div className='footer-section'>
          <img src={Logo} className="footer-logo" alt="notifier" width="150" height="40"/>
          <p className='footer-tagline'>
            Simple notifications, anywhere, anytime.
          </p>
          <p className='footer-copyright'>
            © {currentYear} Notifier. All rights reserved.
          </p>
        </div>

        <div className='footer-section'>
          <h4 className='footer-heading'>Site Map</h4>
          <ul className='footer-links'>
            <li onClick={() => navigateTo("/")}>Home</li>
            <li onClick={() => scrollToSection("mission")}>Our Mission</li>
            <li onClick={() => scrollToSection("offer")}>What We Offer</li>
            <li onClick={() => scrollToSection("pricing")}>Pricing</li>
            <li onClick={() => scrollToSection("help")}>How We Can Help</li>
          </ul>
        </div>

        <div className='footer-section'>
          <h4 className='footer-heading'>Resources</h4>
          <ul className='footer-links'>
            <li onClick={() => window.open("https://portal.notifier-global.com/login")}>Portal Login</li>
            <li onClick={() => navigateTo("/download")}>Download App</li>
            <li onClick={() => navigateTo("/privacy")}>Privacy Policy</li>
          </ul>
        </div>

        <div className='footer-section'>
          <h4 className='footer-heading'>Get Started</h4>
          <p className='footer-text'>
            Ready to simplify your notifications?
          </p>
          <button 
            className='footer-cta'
            onClick={() => window.open("https://portal.notifier-global.com/login")}
          >
            Sign Up Free
          </button>
        </div>
      </div>

      <div className='footer-bottom'>
        <p>Made with ❤️ for developers and businesses</p>
      </div>
    </footer>
  );
};
